import React from 'react';
import NotFoundError from '../components/layouts/ErrorPages/NotFoundError';

const NotFoundErrorPage = () => {
  return <NotFoundError />;
};

export default NotFoundErrorPage;
